import { DefaultTheme } from 'styled-components';

const ThemeDefault: DefaultTheme = {
  background: '#FDFDFD',
  cards: '#F3F2F7',
  text: '#464255',
  lightText: '#C4C4C4',
  green: '#00A389',
  purple: '#AB54DB',
  black: '#000',
};

export default ThemeDefault;
